import React, { useState, useEffect } from 'react';
import Utils from '../utils/nav/Utils';
import IpTelmexTermsContainer from '../components/iptelmex/IpTelmexTermsContainer';
import PrivacyPolicy from '../components/PrivacyPolicy';
import Terms from '../components/terms/Terms';
import { useSelector } from 'react-redux';
import { selectMetadataKeyByRegion } from '../reducers/selectors/metadata';

const IS_TELMEX = Utils.getQueryParameter('telmex');

const TermsRouteView = () => {
  const [hasBackground, setHasBackground] = useState(false);

  const enableNewPage = useSelector(
    selectMetadataKeyByRegion('tyc_update_config'),
  )?.enable;

  useEffect(() => {
    const ishandleTermsActiveNumber = Number(
      localStorage.getItem('handleTermsFromLogin'),
    );

    setHasBackground(Boolean(ishandleTermsActiveNumber));
    localStorage.removeItem('handleTermsFromLogin');
  }, []);

  if (IS_TELMEX) return <IpTelmexTermsContainer />;

  return enableNewPage ? (
    <PrivacyPolicy isBackgroundActive={hasBackground} />
  ) : (
    <Terms />
  );
};

export default TermsRouteView;
